define('flight-components/Dropdown',['require','flight/lib/component'],function(require){

  var component = require('flight/lib/component');
  return component(Dropdown);

  // Constructor
  function Dropdown() {

    this.defaultAttrs({
      toggleSelector: '.js-dropdown__toggle',
      contentSelector: '.js-dropdown__content',
      expandedClass: 'js-dropdown--expanded',
      isActive: false
    });



    this.toggleState = function(ev, data) {
      if (this.isActive) {
        this.collapse();
      } else {
        this.expand();
      }
    };


    this.expand = function() {
      var self = this;
      this.$node.addClass(this.attr.expandedClass);

      setTimeout(function(){
        $(document).on('click.backdrop', function(ev){
          var target = $(ev.target);
          if (target.parents(self.attr.contentSelector).length < 1) {
            self.collapse();
          }
        });

        self.select('contentSelector').addClass('in');
      }, 0);

      this.isActive = true;
    };

    this.collapse = function() {
      this.$node.removeClass(this.attr.expandedClass);

      $(document).off('click.backdrop');
      
      this.select('contentSelector').removeClass('in');

      this.isActive = false;
    };



    this.after('initialize', function() {
      var self = this;

      this.on('click', {
        toggleSelector: this.toggleState
      });

    });

  };

});
